import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import { FilterWrapper, StyleButton, FilterSortSubtitle } from "../../styles";

const NumberOfPeople = (props) => {
  const { selectedNumberOfPeople, numberOfPeople, onFilterClick } = props;

  return (
    <FilterWrapper>
      <FilterSortSubtitle>Number of People</FilterSortSubtitle>
      <Grid container spacing="7px">
        <Grid item xs={6}>
          <StyleButton
            fullWidth
            variant="outlined"
            className={selectedNumberOfPeople.length === 0 ? "selected" : ""}
            onClick={() => onFilterClick("")}
          >
            All
          </StyleButton>
        </Grid>
        {numberOfPeople.map((item) => (
          <Grid item xs={6} key={`number-of-people-${item}`}>
            <StyleButton
              fullWidth
              variant="outlined"
              className={selectedNumberOfPeople.includes(item) ? "selected" : ""}
              onClick={() => onFilterClick(item)}
            >
              {item} People
            </StyleButton>
          </Grid>
        ))}
      </Grid>
    </FilterWrapper>
  );
};

NumberOfPeople.propTypes = {
  selectedNumberOfPeople: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  numberOfPeople: PropTypes.arrayOf(PropTypes.number).isRequired,
  onFilterClick: PropTypes.func.isRequired,
};

export default NumberOfPeople;
